import React from 'react';
import { formatDiffValue } from '../logs.utils';

const TYPE_LABELS = {
  added: 'Ajouté',
  removed: 'Supprimé',
  changed: 'Modifié',
};

/**
 * Différences champ par champ entre deux versions du payload.
 */
export default function LogPayloadDiff({ diff }) {
  if (!diff.length) {
    return (
      <p className="tw-m-0 tw-text-sm tw-text-text-dark-medium-importance">
        Aucune différence.
      </p>
    );
  }

  return (
    <div className="tw-overflow-auto tw-rounded-md tw-border tw-border-solid tw-border-black/10">
      <table className="tw-w-full tw-text-xs tw-font-mono tw-border-collapse">
        <thead>
          <tr className="tw-bg-[#F7F8FA] tw-text-left tw-font-work tw-text-text-dark-medium-importance">
            <th className="tw-px-2 tw-py-1 tw-font-semibold">Champ</th>
            <th className="tw-px-2 tw-py-1 tw-font-semibold">Avant</th>
            <th className="tw-px-2 tw-py-1 tw-font-semibold">Après</th>
          </tr>
        </thead>
        <tbody>
          {diff.map((change) => (
            <tr
              key={change.path}
              className="tw-border-0 tw-border-t tw-border-solid tw-border-black/5 tw-align-top"
            >
              <td className="tw-px-2 tw-py-1 tw-break-all">
                {change.path}
                <span className="tw-sr-only">
                  {' '}
                  ({TYPE_LABELS[change.type]})
                </span>
              </td>
              <td className="tw-px-2 tw-py-1 tw-break-all tw-bg-status-negative/5 tw-text-status-negative">
                {change.type === 'added' ? '—' : formatDiffValue(change.before)}
              </td>
              <td className="tw-px-2 tw-py-1 tw-break-all tw-bg-status-positive/5 tw-text-[#0B7A5C]">
                {change.type === 'removed'
                  ? '—'
                  : formatDiffValue(change.after)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
